import { render } from "./FriendSuggestItem.vue?vue&type=template&id=901f6e9e"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__